import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styled-components';
import { flexbox, space } from 'styled-system';
import { Box } from '@design-system/box';
import { useGridContext } from '../contexts/GridContext';
import { getBpNum } from '../utils/getBpNum';
export const Row = forwardRef((_a, ref) => {
    var { children, flexWrap, justifyCenter } = _a, otherProps = __rest(_a, ["children", "flexWrap", "justifyCenter"]);
    const { colGap, columnsInMobile } = useGridContext();
    return (_jsx(RowStyled, Object.assign({ flexDirection: {
            _: columnsInMobile ? 'row' : 'column',
            m: 'row',
            l: 'row',
            xl: 'row',
        }, flexWrap: flexWrap || 'wrap', justifyContent: justifyCenter ? 'center' : 'flex-start', ml: {
            _: columnsInMobile ? getBpNum(colGap, '_') * -1 : 0,
            m: getBpNum(colGap, 'm') * -1,
            l: getBpNum(colGap, 'l') * -1,
            xl: getBpNum(colGap, 'xl') * -1,
        } }, otherProps, { ref: ref, children: children })));
});
const RowStyled = styled(Box) `
  ${flexbox}
  ${space}

  display: flex;
  height: ${({ height }) => height || '100%'};
  position: relative;
`;
//# sourceMappingURL=Row.js.map